import api from '../../api'
import { ChannelType, Subscription } from '../../types'

export const topicChannels: ChannelType[] = ['email', 'text', 'push', 'in_app', 'webhook']

export const internalTopicChannels: ChannelType[] = ['in_app', 'webhook']

export interface TopicChannel {
    channel: ChannelType
    master?: Subscription
    topics: Subscription[]
}

const topicPageSize = 100

// The shared search turns `limit: -1` into `limit 0` rather than unbounded, so every page has to be walked.
export const loadTopics = async (projectId: number | string) => {
    const topics: Subscription[] = []
    let cursor: string | undefined
    do {
        const page = await api.subscriptions.search(projectId, { limit: topicPageSize, cursor })
        topics.push(...page.results)
        cursor = page.nextCursor || undefined
    } while (cursor)
    return topics
}

export const groupTopicChannels = (items: Subscription[], query = ''): TopicChannel[] => {
    const match = query.trim().toLowerCase()
    return topicChannels.map(channel => {
        const rows = items.filter(item => item.channel === channel)
        return {
            channel,
            master: rows.find(item => item.is_channel),
            topics: rows.filter(item => !item.is_channel && item.name.toLowerCase().includes(match)),
        }
    })
}
